var moduleMap = {
	"./ibex_dashboard": () => {
		return Promise.all([__webpack_require__.e(983), __webpack_require__.e(866), __webpack_require__.e(623), __webpack_require__.e(536), __webpack_require__.e(63), __webpack_require__.e(279), __webpack_require__.e(933), __webpack_require__.e(931), __webpack_require__.e(914), __webpack_require__.e(332), __webpack_require__.e(864)]).then(() => (() => ((__webpack_require__(17391)))));
	},
	"./ibex_reducers": () => {
		return Promise.all([__webpack_require__.e(983), __webpack_require__.e(63), __webpack_require__.e(571)]).then(() => (() => ((__webpack_require__(75571)))));
	},
	"./ibex_Async_Actions_reducers": () => {
		return Promise.all([__webpack_require__.e(983), __webpack_require__.e(866), __webpack_require__.e(536), __webpack_require__.e(63), __webpack_require__.e(279), __webpack_require__.e(712)]).then(() => (() => ((__webpack_require__(25430)))));
	},
	"./ibex_state_reducers": () => {
		return Promise.all([__webpack_require__.e(983), __webpack_require__.e(866), __webpack_require__.e(536), __webpack_require__.e(63), __webpack_require__.e(279), __webpack_require__.e(712)]).then(() => (() => ((__webpack_require__(38459)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});